import photo1 from "../assets/images/who-runs/1.jpg";
import photo2 from "../assets/images/who-runs/2.png";
import photo3 from "../assets/images/who-runs/3.jpg";
import photo4 from "../assets/images/who-runs/4.jpg";

export const WHO_RUNS_PHOTOS = [
  { src: photo1, alt: "Мария Бурлакова" },
  { src: photo2, alt: "Мария Бурлакова на встрече клуба" },
  { src: photo3, alt: "Мария Бурлакова на встрече клуба" },
  { src: photo4, alt: "Мария Бурлакова с участниками клуба" },
];
